/**
 * Given an array of gradeGroup objects, each containing a grade_minimum property,
 * order the groups in ascending order based on the aforementioned property.
 * @param {Array} gradeGroups - An array of object-literals each representing a grade-group.
 * @returns {Array} [{gradeGroup}] - An array of object-literals each representing a grade-group.
 */
const sortGradeGroups = (gradeGroups = []) => {
  const sortedGroups = gradeGroups.sort((a, b) => {
    return a.grade_minimum - b.grade_minimum;
  });

  return sortedGroups;
};

export default sortGradeGroups;
